"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _Row = _interopRequireDefault(require("../Layout/Row"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _utils = require("../utils");

var _DropdownInputSelectedValue = _interopRequireDefault(require("./DropdownInputSelectedValue"));

var _excluded = ["value", "single", "plural", "className", "open", "renderSelected", "placeholder", "renderComponent", "dataKey", "variant"];

var BtnArrowUp = function BtnArrowUp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.529 0a.474.474 0 0 0-.357.137L.137 4.172a.488.488 0 0 0 .69.689L4.53 1.156l3.705 3.705a.488.488 0 0 0 .69-.69L4.89.138A.477.477 0 0 0 4.53 0z"
  }));
};

BtnArrowUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.0618038 4.9977479"
};
var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    root: {
      transition: theme.transition.create('color'),
      color: theme.palette.secondary["default"]
    },
    icon: {
      fill: 'currentColor',
      transition: theme.transition.create('transform')
    },
    active: {
      color: theme.palette.primary["default"]
    },
    rotate: {
      transform: 'rotate(180deg)'
    }
  };
});
exports.useStyles = useStyles;

var DropdownLabelInput = /*#__PURE__*/_react["default"].forwardRef(function DropdownLabelInput(_ref, ref) {
  var _cn2;

  var value = _ref.value,
      single = _ref.single,
      plural = _ref.plural,
      className = _ref.className,
      open = _ref.open,
      renderSelected = _ref.renderSelected,
      placeholder = _ref.placeholder,
      renderComponent = _ref.renderComponent,
      dataKey = _ref.dataKey,
      variant = _ref.variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  var renderValueComponent = renderSelected || renderComponent || null;
  return /*#__PURE__*/_react["default"].createElement(_Row["default"], (0, _extends2["default"])({
    ref: ref,
    fullWidth: true,
    wrap: false,
    className: (0, _classnames["default"])(classes.root, className),
    align: "center",
    justify: "between",
    spacing: 2
  }, props), /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, classes.active, !(0, _utils.isEmpty)(value)))
  }, /*#__PURE__*/_react["default"].createElement(_DropdownInputSelectedValue["default"], {
    value: value,
    variant: variant,
    renderValue: renderValueComponent,
    single: single,
    plural: plural
  }), (0, _utils.isEmpty)(value) && /*#__PURE__*/_react["default"].createElement(_TextField["default"], null, " ", placeholder)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: BtnArrowUp,
    className: (0, _classnames["default"])(classes.icon, (_cn2 = {}, (0, _defineProperty2["default"])(_cn2, classes.rotate, !open), (0, _defineProperty2["default"])(_cn2, classes.active, open), _cn2)),
    width: 10,
    height: 10
  }));
});

DropdownLabelInput.displayName = 'DropdownLabelInput';
var _default = DropdownLabelInput;
exports["default"] = _default;